import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import {
  convertIUnderwriterProfileSummaryResponseToIUnderwriterProfileSummaryData,
  IUnderwriterProfileSummaryData,
  IUnderwriterProfileSummaryResponse,
} from 'types/administration/pricing/IUnderWriterProfileSummary';
import { IPaginationQuery } from 'types/rest/IPaginationQuery';
import { convertFromIPaginationQueryToIPaginationQueryRequest } from 'types/rest/IPaginationQueryRequest';
import {
  convertIUnderwriterProfileResponseToIUnderwriterProfileData,
  IUnderwriterProfileData,
  IUnderwriterProfileResponse,
} from 'types/administration/pricing/underwriterProfileInterfaces/IUnderwriterProfile';
import { paramsSerializer } from 'API/paramsSerializer';

export const getSummaryUnderwriterProfilesAsyncV2 = async (
  query: IPaginationQuery
): Promise<IUnderwriterProfileSummaryData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IUnderwriterProfileSummaryResponse[]>(`cd_items/underwriterProfiles`, {
      params: convertFromIPaginationQueryToIPaginationQueryRequest(query),
      paramsSerializer,
    })
    .then((response) => response.data.map(convertIUnderwriterProfileSummaryResponseToIUnderwriterProfileSummaryData))
    .catch(axiosErrorHandler);

export const getUnderwriterProfileAsync = async (pathName: string): Promise<IUnderwriterProfileData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IUnderwriterProfileResponse>(`cd_items/underwriterProfiles/${pathName}`)
    .then((response) => convertIUnderwriterProfileResponseToIUnderwriterProfileData(response.data))
    .catch(axiosErrorHandler);
